import { render, staticRenderFns } from "./loadpage.vue?vue&type=template&id=8e507e18&"
import script from "./loadpage.vue?vue&type=script&lang=js&"
export * from "./loadpage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports